import { render, staticRenderFns } from "./WizardItem.vue?vue&type=template&id=372eb377&scoped=true&"
import script from "./WizardItem.vue?vue&type=script&lang=ts&"
export * from "./WizardItem.vue?vue&type=script&lang=ts&"
import style0 from "./WizardItem.vue?vue&type=style&index=0&id=372eb377&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372eb377",
  null
  
)

export default component.exports